import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private router: Router) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
    const started = Date.now();
      let tokenType = sessionStorage.getItem('customToken') === null ? sessionStorage.getItem('accessToken') : sessionStorage.getItem('customToken');
      if(tokenType){
        const clonedreq = req.clone({
        headers: req.headers.set(
          'Authorization',
          `Bearer ${tokenType}`
        ).append('userId', `${sessionStorage.getItem('userId')}`).append('Access-Control-Allow-Origin', 'tce-project.tcsappsdev.com')
          .append('Cache-Control', 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0')
          .append('X-XSS-Protection', '1; mode=block')
          .append("X-Frame-Options", "deny")
          .append('Content-Security-Policy', 'frame-ancestors "self"')
      })
      return next.handle(clonedreq).pipe(tap(event => {
        const elapsed = Date.now() - started;
        if (event instanceof HttpResponse) {
        };
      }), catchError(err => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            if (err.error.errDetails === 'Authentication Failed') {
              this.router.navigateByUrl('/login');
            }
            err.message
          }
        }
        return of(err);
      }));
      }
 else if(sessionStorage.getItem('userId')) {
      req = req.clone({
        setHeaders: { userId: sessionStorage.getItem('userId') }
      });
    } else {
      req = req.clone({
        setHeaders: { userId: "admin@tcs.com" }
      });
    }
    return next.handle(req);
  }
}